import React from "react";

export const ErrorMessage = ({ errorMessage }) => {
  return <p className="h-[20px] text-sm mb-5 text-red-400">{errorMessage}</p>;
};
